import { server } from '../helpers';

export const DEAL_IMPRESSION = {
  DEAL_SERP_IMPRESSION: 12,
  DEAL_IMPRESSION: 13,
  BOOK_DEAL_CLICK: 14,
} as const;

export type DealImpressionType = (typeof DEAL_IMPRESSION)[keyof typeof DEAL_IMPRESSION];

export const impressionService = {
  storeDealImpressions,
};

function storeDealImpressions({
  items,
  type,
}: {
  items: { dealId: number; placeId: number }[];
  type: DealImpressionType;
}): Promise<void> {
  return server.request
    .post('/impressions/deals', { type, items })
    .then(server.handleSuccess)
    .catch(server.handleError);
}
